var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-12"},[(_vm.loginUserType === 'patient')?_c('LoginPatient'):_c('LoginNurse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }